import { Component, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { AkitaScreenQuery } from '@app/akita/screen/state/screen.query';
import { ScreenSizeInfoState } from '@app/akita/screen/state/screen.store';
import { AkitaRouterQuery } from '@app/akita/router/state/router.query';
import { AsyncPipe } from '@angular/common';
import { FooterComponent } from '../shared/components/new-footer/footer.component';
import { FeaturedReviewsCardComponent } from '../featured/components/featured-reviews-card/featured-reviews-card.component';
import { TranslocoModule } from '@ngneat/transloco';
import { PictureComponent } from '@app/shared/components/picture/picture.component';
// eslint-disable-next-line max-len
import { KeyboardArrowRightIconComponent } from '@app/shared/components/icons/generated/keyboard-arrow-right/keyboard-arrow-right.component';
import { AkitaRouterService } from '@app/akita/router/state/router.service';
import { AkitaProductsQuery } from '@app/akita/api/products/state/products.query';
import {
  Swiper,
  Navigation,
  Pagination,
  FreeMode,
  A11y,
  Controller,
  Thumbs,
  HashNavigation,
  Autoplay,
} from 'swiper';
import { SwiperModule } from 'swiper/angular';

import { REVIEWS_DATA } from './highlight-reviews.data';
import { StarFilledIconComponent } from '@app/shared/components/icons/generated/star-filled/star-filled.component';
import { SubscribeBannerComponent } from '@app/shared/components/subscribe-banner/subscribe-banner.component';

Swiper.use([
  Navigation,
  Pagination,
  FreeMode,
  A11y,
  Controller,
  Thumbs,
  HashNavigation,
  Autoplay,
]);

@Component({
  selector: 'app-customer-reviews',
  templateUrl: './customer-reviews.template.html',
  styleUrls: ['./customer-reviews.style.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    TranslocoModule,
    FeaturedReviewsCardComponent,
    FooterComponent,
    AsyncPipe,
    PictureComponent,
    SwiperModule,
    KeyboardArrowRightIconComponent,
    CustomerReviewsComponent,
    StarFilledIconComponent,
    SubscribeBannerComponent,
  ],
})
export class CustomerReviewsComponent implements OnDestroy {
  public isBrowser: boolean;
  public rtlMode: boolean;

  public highlightReviews = REVIEWS_DATA.en;

  public imageBannerUrl: string | null = '/assets/images/reviews_banner.webp';
  public thumbsSwiper: any;

  public language: string | null = null;
  public biggerThan$: Observable<ScreenSizeInfoState>;
  public inFullScreenMode$: Observable<boolean>;
  public readonly homeUrlFragment: string[];

  private readonly destroySubject: Subject<void>;

  constructor(
    private readonly akitaScreenQuery: AkitaScreenQuery,
    private readonly akitaRouterQuery: AkitaRouterQuery,
    private readonly akitaRouterService: AkitaRouterService,
    private readonly akitaProductsQuery: AkitaProductsQuery
  ) {
    this.destroySubject = new Subject();
    this.isBrowser = this.akitaRouterQuery.isBrowser;
    this.biggerThan$ = this.akitaScreenQuery.selectBiggerThan();
    this.inFullScreenMode$ = this.akitaRouterQuery.selectInFullScreenMode();

    this.rtlMode = this.akitaRouterQuery.isRtlLanguage;

    this.language = this.akitaProductsQuery.validateLocale().language;
    this.highlightReviews = this.language === 'ar' ? REVIEWS_DATA.ar : REVIEWS_DATA.en;
    this.homeUrlFragment = this.akitaRouterQuery.homeUrlFragment;
  }

  public navigateToProducts(): void {
    const fragment = [...this.homeUrlFragment, 'products'];

    this.akitaRouterService.navigate(fragment, this.akitaRouterQuery.queryParamsToKeep);
  }

  public navigateToModel(model: string): void {
    const fragment = [...this.homeUrlFragment];
    fragment.push('c', 'model', model);

    this.akitaRouterService.navigate(fragment, this.akitaRouterQuery.queryParamsToKeep);
  }

  public range(length: number | undefined): Array<number> {
    return Array(Math.floor(length || 0));
  }

  public ngOnDestroy(): void {
    this.destroySubject.next();
    this.destroySubject.complete();
  }
}
